import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ClearConstantService {

    public clearRequested: Subject<void> = new Subject();
    public clearSelectedRequested: Subject<void> = new Subject();
    public clearInternalSelectedRequested: Subject<void> = new Subject();

    constructor() {
    }

    public clearConstants() {
        this.clearRequested.next();
    }

    public clearSelected() {
        this.clearSelectedRequested.next();
    }

    public clearInternalSelected() {
        this.clearInternalSelectedRequested.next();
    }
}
